import React, {useEffect} from 'react';
import {Route, Redirect, useHistory} from 'react-router-dom';
import {checkCookie, getCookie} from 'ubs-framework/v2/common/cookie';
import {useDispatch, useSelector} from "react-redux";
import {sendData} from "../store/actions";

const PrivateRoute = ({component: Component, ...rest}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const _IA = useSelector(e => e.common.isAuthenticated)
    useEffect(() => {
        if (!checkCookie('ubs_token')) history.push('login')
        else if (!_IA) sendData(dispatch, 'authenticate', {token: getCookie("ubs_token")})
    }, [])

    return (
        <React.Fragment>
            {_IA && <Route {...rest} render={props => (
                checkCookie('ubs_token') ? <Component {...props} /> : <Redirect to="/login"/>
            )}/>}
        </React.Fragment>
    );
};

export default PrivateRoute;
